<template>
  <div style="height: 400px;">
    <Table :data="list" :columns="columns" :pages="pages"></Table>
  </div>
</template>
<script>
import InvoiceService from "@/apis/InvoiceService";
import orderService from "@/apis/orderService";
import Table from "@/components/new-table.vue";
import FeeUndoInvoicing from "./fee-undo-invoicing.vue";
import { OrderTypeLabel } from "@/service/enum"
export default {
  components: { Table, FeeUndoInvoicing },
  data() {
    return {
      list: [],
      columns: [
        { label: "订单号", prop: "orderNo", "min-width": "120px" },
        { label: "应用名称", prop: "appName", "min-width": "120px" },
        { label: "套餐名称", prop: "packageName", "min-width": "90px" },
        {
          label: "购买时长", "min-width": '80px', render: (h, { row }) => {
            let num = row.buyPeriodNum * row.buyNums + (['', '天', '个月'][row.packagePeriodUnit])
            return <div> {num}</div>
          }
        },
        {
          label: "付款金额", prop: "sumPrice", "min-width": '90px', render: (h, { row }) => {
            return <div> {orderService.toYuan(row.sumPrice)} </div>
          }
        },
        {
          label: "平台服务费", prop: "plantPrice", "min-width": "90px", render: (h, { row }) => {
            return <div> {orderService.toYuan(row.plantPrice)} </div>
          }
        },
        { label: "创建时间", prop: "orderCreateTime", "min-width": "120px" },
        {
          label: "订单类型", prop: "maxUsers", "min-width": '80px', render: (h, { row }) => {
            return <div> {OrderTypeLabel[row.orderAppType] || ''} </div>
          }
        },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
      orderId: ""
    }
  },
  methods: {
    getList(orderId) {
      this.list = [];
      if (orderId) this.orderId = orderId;
      const page = this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      InvoiceService.getFeeApplyDetailList(page, pageSize, this.orderId).then(res => {
        this.list = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.pages.props["current-page"] = 1;
      this.getList();
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getList();
    },
    selectionChange(list) {
      this.selectList = list;
    }
  }
}
</script>
